/**
 * MOCK_TEMPLATES — fallback copies of the Jerny.CsCodeTemplates notes.
 * Used by CsCodeTemplateEngine only when the BE cache is empty (not yet fetched / offline dev).
 * These MUST stay in sync with the real notes in Jerny.CsCodeTemplates — source of truth is the notes,
 * this file is a convenience mirror so the widget works before fetchAll() has run.
 *
 * No `using` statement is ever hardcoded here (correction 20260701) — every code file's usings come
 * from %BASE_USINGS% (System, System.Linq etc, form-editable) + %CUSTOM_USINGS% (KD8/Treetek specific).
 *
 * Note RKs (Jerny.CsCodeTemplates):
 * PluginClass=310fc30de9dd4942b5d6f802bb2f14dc, PluginContext=f18fe066ddce49a78e8399b71af307ab,
 * PluginConfigurator=9b64a520a8c540e983f2f1d9d4e89097, PluginContainerModule=a3646243f840410eb638b7bac902133a,
 * PluginCsproj=ea87d5c1c8884750932395015dfcf2cb, DataDbContext=a2cca0c44b6d4d76a145efab0c3923be,
 * DataDbConnection=a87ce5e5d64847d2b9324acf927ed46f, DataContainerModule=f1d550cf0d2643ef90dfbd4576b9ba8b,
 * DataEfCommands=c809959d95f84f64955a02ca8278acdb, DataCsproj=b410b4617e6540878d7863a735daa394,
 * CommonCsproj=4e1fde2218414674a8431c8cd4ed96f9
 */
export const MOCK_TEMPLATES = {
    PluginClass: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Plugin
{
    public interface I%PLUGIN_NAME%Plugin : IEnginePlugin
    {

    }


    public class %PLUGIN_NAME%Plugin : EnginePluginBase<I%PLUGIN_NAME%PluginContext>, I%PLUGIN_NAME%Plugin
    {
        private readonly I%PLUGIN_NAME%PluginContext _ctx;


        private readonly IEpochHelper _ep;


        public %PLUGIN_NAME%Plugin(
            I%PLUGIN_NAME%PluginContext ctx,

            IEpochHelper ep,
            ILogHandler logHandler
        ) : base(ctx, logHandler)
        {
            _ctx = GetContext();
            _ctx.Active = true;

            _ep = ep;
        }



        public override int Initialize(IAppSettings app)
        {
            var r = base.Initialize(app);
            if (r < 0) return r;

            // TODO: initialize dependencies here

            return r;
        }


        public override async Task<int> Bootup()
        {
            if (!_ctx.Active) return 0;
            var r = await base.Bootup();

            if (r < 0) return r;

            // TODO: bootup logic here

            return r;
        }




        public override Task<int> Run()
        {
            if (!_ctx.Active) return Task.FromResult(0);
            var r = base.Run();

            // TODO: run logic here

            return r;
        }



        public override async Task<int> Cleanup()
        {
            if (!_ctx.Active) return 0;
            var r = await base.Cleanup();

            // TODO: cleanup logic here

            return r;
        }
    }
}
`,

    PluginContext: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Plugin
{
    public interface I%PLUGIN_NAME%PluginContext : IEnginePluginContext
    {

        /// <summary>
        /// TODO: describe target service(s) for updates
        /// </summary>
        List<string> Targets { get; set; }


        /// <summary>
        /// delay time in ms for processing
        /// buffered rest request
        /// </summary>
        int RestDelay { get; set; }


        /// <summary>
        /// The app name for values
        /// </summary>
        string AppName { get; set; }

    }


    public class %PLUGIN_NAME%PluginContext : EnginePluginContextBase, I%PLUGIN_NAME%PluginContext
    {
        public List<string> Targets { get; set; } = [];

        public string AppName { get; set; }

        public int RestDelay { get; set; } = 500;

    }
}
`,

    PluginConfigurator: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Plugin.Utils
{



    /// <summary>
    /// configurator for %PLUGIN_NAME% Engine plugin
    /// </summary>
    public interface I%PLUGIN_NAME%PluginConfigurator : IPluginConfigurator
    {
    }



    public class %PLUGIN_NAME%PluginConfigurator : ConfiguratorBase<I%PLUGIN_NAME%PluginContext>, I%PLUGIN_NAME%PluginConfigurator
    {

        public %PLUGIN_NAME%PluginConfigurator(
            I%PLUGIN_NAME%PluginContext ctx,


            ILogHandler logHandler
        ) : base(ctx, logHandler)
        {
            Init(this, logHandler);
        }



        /// <summary>
        /// configure plugin context
        /// </summary>
        /// <returns></returns>
        public IEnginePluginContext Configure()
        {

            // TODO: set active flag / app name / target services
            _ctx.Active = true;
            _ctx.AppName = "%PROJECT_NAME%";

            // TODO: set target service for RT updates
            // _ctx.Targets.Add("PortalService");



            return _ctx;
        }

    }
}
`,

    PluginContainerModule: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Plugin
{
    public class ContainerModule : ContainerModuleBase2
    {

        public override Container RegisterTo(
            Container container,
            LifeStyleTarget lifeStyleTarget,
            IAppSettings app,
            IConfigurationRoot config
        )
        {

            base.RegisterTo(container, lifeStyleTarget, app, config);

            new ConventionBindingBuilder(container)
                .FromThisAssembly()
                .SelectAllClasses()

                .Excluding<IEnginePluginContext>()
                .Excluding<IInjectionIgnored>()

                .BindDefaultInterface(lifeStyleTarget);

            container.RegisterFunc<I%PLUGIN_NAME%PluginContext>();


            return container;
        }
    }
}
`,

    PluginCsproj: `\uFEFF<Project Sdk="Microsoft.NET.Sdk">

  <PropertyGroup>
    <TargetFramework>net8.0</TargetFramework>
    <ImplicitUsings>enable</ImplicitUsings>
    <Nullable>disable</Nullable>

    <AssemblyName>$(MSBuildProjectName)</AssemblyName>
    <PackageId>$(MSBuildProjectName)</PackageId>
    <Description>%DESCRIPTION%</Description>
    <Copyright>2026 treetek</Copyright>
    <Company>treetek</Company>
    <Authors>%AUTHOR%</Authors>
    <GenerateDocumentationFile>true</GenerateDocumentationFile>
    <GeneratePackageOnBuild>false</GeneratePackageOnBuild>

  </PropertyGroup>


  <PropertyGroup>
    <WarningsAsErrors>$(WarningsAsErrors);NU1605</WarningsAsErrors>
    <NoWarn>1591</NoWarn>
    <RootNamespace>$(MSBuildProjectName.Replace(" ", "_"))</RootNamespace>
  </PropertyGroup>


  <ItemGroup>
%PACKAGE_REFERENCES%
  </ItemGroup>


  <ItemGroup>
%PROJECT_REFERENCES%
  </ItemGroup>


</Project>
`,

    DataDbContext: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Data.Plugin
{


    public interface I%PREFIX%%PROJECT_NAME%DbContext : IDbContextEF
    {
    }

    public class %PREFIX%%PROJECT_NAME%DbContext : DbContext, I%PREFIX%%PROJECT_NAME%DbContext
    {
        public int Order { get; set; } = 10;

        public string ConnectionStr { get; set; }



        // TODO: add your DbSet properties here, e.g.:
        // /// <summary>
        // /// Holds MyEntity records
        // /// </summary>
        // public DbSet<MyEntity> MyEntities { get; set; }





        /// <summary>
        /// override static interface method for IServiceCollection AddDbContext
        /// </summary>
        /// <param name="s">the connection str </param>
        /// <returns></returns>
        public static Action<DbContextOptionsBuilder> CreateOptionBuilderAction(string s)
        {
            return o => Bme6MigratorBase.CreateContextOptionBuilder<%PREFIX%%PROJECT_NAME%DbContext>(s);
        }

        /// <summary>
        /// override static interface method for IServiceCollection AddDbContext
        /// </summary>
        /// <param name="connectionStr"></param>
        /// <returns></returns>
        public static IDbContextEF CreateContext(string connectionStr)
        {
            var opt = Bme6MigratorBase.CreateContextOptionBuilder<%PREFIX%%PROJECT_NAME%DbContext>(connectionStr);
            var db03 = new %PREFIX%%PROJECT_NAME%DbContext(opt.Options);
            db03.ConnectionStr = connectionStr;

            return db03;
        }







        public %PREFIX%%PROJECT_NAME%DbContext()
        {

        }

        public %PREFIX%%PROJECT_NAME%DbContext(DbContextOptions<%PREFIX%%PROJECT_NAME%DbContext> options)
            : base(options)
        {
        }

        protected override void OnConfiguring(DbContextOptionsBuilder optionsBuilder)
        {
            if (optionsBuilder.IsConfigured) return;

            if (string.IsNullOrEmpty(ConnectionStr))
            {
                Console.WriteLine($"%PREFIX%%PROJECT_NAME%DbContext.OnConfigure: Using Bme6MigratorBase ConStr");
                ConnectionStr = Bme6MigratorBase.ConnectionStr;
            }

            optionsBuilder.UseMySql(ConnectionStr, Bme6MigratorBase.GetMySqlVersion());
        }



    }
}
`,

    DataDbConnection: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Data.Plugin
{
    public interface I%PREFIX%%PROJECT_NAME%DbConnection : IServiceDbConnectionBase
    {
    }

    public class %PREFIX%%PROJECT_NAME%DbConnection : ServiceDbConnectionBase, I%PREFIX%%PROJECT_NAME%DbConnection
    {

        public %PREFIX%%PROJECT_NAME%DbConnection()
        {

        }

        public %PREFIX%%PROJECT_NAME%DbConnection(
            string connectionStr,
            IDbConnectionFactory factory,
            ILogHandler logger
        )
            : base(factory, logger)
        {
            ConnectionStr = connectionStr;
        }


    }
}
`,

    DataContainerModule: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Data.Plugin
{
    public class ContainerModule : ContainerModuleBase2
    {

        public override Container RegisterTo(
            Container container,
            LifeStyleTarget lifeStyleTarget,
            IAppSettings app,
            IConfigurationRoot config
        )
        {

            base.RegisterTo(container, lifeStyleTarget, app, config);

            new ConventionBindingBuilder(container)
                .FromThisAssembly()
                .SelectAllClasses()

                .Excluding<IInjectionIgnored>()

                .BindAllInterfaces(lifeStyleTarget);


            var r = RegisterDbConnection<%PREFIX%%PROJECT_NAME%DbConnection>();


            return container;
        }


        private new int RegisterDbConnection<TInstance>(string tag = "")
              where TInstance : class, IServiceDbConnectionBase, new()
        {
            if (string.IsNullOrEmpty(tag))
                tag = typeof(TInstance).Name;


            var conStr = AppSettings.GetConnectionStr($"%{tag}%");
            if (string.IsNullOrEmpty(conStr))
            {
                AppSettings.Logger.Log(LogLevel.Fatal, $"Missing connection string {tag}!");
                return -1;
            }

            var p1 = new TInstance();
            p1.ConnectionStr = conStr;
            p1.Set(new MySqlConnectionFactory(), AppSettings.Logger);

            if (AppSettings.AddonTypes == null || AppSettings.AddonTypes.Count == 0)
            {
                AppSettings.Logger.Log(LogLevel.Fatal, "AddonTypes types not resolved!");
                return -1;
            }

            var iType = $"I{typeof(TInstance).Name}";
            var interfaceType = AppSettings.AddonTypes.FirstOrDefault(x => x.Name == iType);
            if (interfaceType == null)
            {
                AppSettings.Logger.Log(LogLevel.Fatal, $"Missing interface type {tag}!");
                return -1;
            }


            _container.RegisterSingleton(interfaceType, () => p1);


            return 0;
        }
    }
}
`,

    DataEfCommands: `
add-migration "TODO: describe migration"  -s %HOSTED_SERVICE% -Project %PREFIX%.%PROJECT_NAME%.Data.Plugin  -Context %PREFIX%%PROJECT_NAME%DbContext


# Remove-Migration -s %HOSTED_SERVICE% -Project %PREFIX%.%PROJECT_NAME%.Data.Plugin  -Context %PREFIX%%PROJECT_NAME%DbContext
`,

    DataCsproj: `\uFEFF<Project Sdk="Microsoft.NET.Sdk">

  <PropertyGroup>
    <TargetFramework>net8.0</TargetFramework>
    <ImplicitUsings>disable</ImplicitUsings>
    <Nullable>disable</Nullable>

    <AssemblyName>$(MSBuildProjectName)</AssemblyName>
    <PackageId>$(MSBuildProjectName)</PackageId>
    <Description>%DESCRIPTION%</Description>
    <Copyright>2026 treetek</Copyright>
    <Company>treetek</Company>
    <Authors>%AUTHOR%</Authors>
    <GenerateDocumentationFile>true</GenerateDocumentationFile>
    <GeneratePackageOnBuild>false</GeneratePackageOnBuild>

  </PropertyGroup>


  <PropertyGroup>
    <WarningsAsErrors>$(WarningsAsErrors);NU1605</WarningsAsErrors>
    <NoWarn>1591</NoWarn>
    <RootNamespace>$(MSBuildProjectName.Replace(" ", "_"))</RootNamespace>
  </PropertyGroup>


  <ItemGroup>
%PACKAGE_REFERENCES%
  </ItemGroup>


  <ItemGroup>
%PROJECT_REFERENCES%
  </ItemGroup>


  <ItemGroup>
    <Folder Include="Migrations\\" />
  </ItemGroup>

</Project>
`,

    CommonCsproj: `\uFEFF<Project Sdk="Microsoft.NET.Sdk">

  <PropertyGroup>
    <TargetFramework>net8.0</TargetFramework>
    <ImplicitUsings>enable</ImplicitUsings>
    <Nullable>disable</Nullable>

    <AssemblyName>$(MSBuildProjectName)</AssemblyName>
    <PackageId>$(MSBuildProjectName)</PackageId>
    <Description>%DESCRIPTION%</Description>
    <Copyright>2026 treetek</Copyright>
    <Company>treetek</Company>
    <Authors>%AUTHOR%</Authors>
    <GenerateDocumentationFile>true</GenerateDocumentationFile>
    <GeneratePackageOnBuild>false</GeneratePackageOnBuild>

  </PropertyGroup>


  <PropertyGroup>
    <WarningsAsErrors>$(WarningsAsErrors);NU1605</WarningsAsErrors>
    <NoWarn>1591</NoWarn>
    <RootNamespace>$(MSBuildProjectName.Replace(" ", "_"))</RootNamespace>
  </PropertyGroup>


  <ItemGroup>
%PACKAGE_REFERENCES%
  </ItemGroup>


  <ItemGroup>
%PROJECT_REFERENCES%
  </ItemGroup>


</Project>
`,
};

/**
 * MOCK_TEMPLATE_RKS — strategyId -> note RK, used by CodeTemplateResolver to build fallback
 * CodeTemplateItem entries while the BE cache is empty. Same RKs as documented in the MOCK_TEMPLATES
 * header comment — kept here as actual data (not just a comment) so the resolver can use it.
 */
export const MOCK_TEMPLATE_RKS = {
    PluginClass: '310fc30de9dd4942b5d6f802bb2f14dc',
    PluginContext: 'f18fe066ddce49a78e8399b71af307ab',
    PluginConfigurator: '9b64a520a8c540e983f2f1d9d4e89097',
    PluginContainerModule: 'a3646243f840410eb638b7bac902133a',
    PluginCsproj: 'ea87d5c1c8884750932395015dfcf2cb',
    DataDbContext: 'a2cca0c44b6d4d76a145efab0c3923be',
    DataDbConnection: 'a87ce5e5d64847d2b9324acf927ed46f',
    DataContainerModule: 'f1d550cf0d2643ef90dfbd4576b9ba8b',
    DataEfCommands: 'c809959d95f84f64955a02ca8278acdb',
    DataCsproj: 'b410b4617e6540878d7863a735daa394',
    CommonCsproj: '4e1fde2218414674a8431c8cd4ed96f9',
};

/**
 * MOCK_TEMPLATE_FORMATS — strategyId -> format (file extension), mirrors the real notes' `format`
 * field (correction 20260704h) while the BE cache is empty. Only templates that AREN'T plain .cs
 * need an entry — CodeTemplateItem defaults missing/undefined to 'cs'. The three *Csproj templates
 * are 'xml' for consistency (matches CsCodeTemplateEditorDlg.langForStrategyId's syntax highlighting
 * rule), though in practice they never go through CsCodeGenGenerator.resolveTemplateFileName/emitByRk
 * — their fileName is a hardcoded emitByTitle call, not derived from format.
 */
export const MOCK_TEMPLATE_FORMATS = {
    PluginCsproj: 'xml',
    DataCsproj: 'xml',
    CommonCsproj: 'xml',
    DataEfCommands: 'txt',
};

/**
 * MOCK_DEFAULTS — fallback copy of the CsCodeGenDefaults note (Jerny.CsCodeTemplates, rk=f8bebbe09214482eabed8da8c2a76af9).
 * Used by CsCodeTemplateEngine.getDefaults() only when the BE cache is empty (not yet fetched / offline dev).
 * MUST stay in sync with the real note — source of truth is the note, this is a convenience mirror.
 */
export const MOCK_DEFAULTS = {
    prefix: 'KD8',
    projectNamePlaceholder: 'MyPlugin',
    pluginNamePlaceholder: 'MyPlugin',
    descriptionPlaceholder: 'describe this plugin',
    author: 'Kim Bouwman',
    hostedServicePlaceholder: 'KD8.DataCollectorService',
    sharedPackages: [{ name: 'Treetek.net8', version: '8.0.8.114' }],
    baseUsings: ['System', 'System.Linq'],
    commonUsings: [
        'KD8.Core.Exchanges.Engines.Utils',
        'Treetek.net8.Core.AppManagement',
        'Treetek.net8.Core.Interfaces',
        'Treetek.net8.Core.Utils',
    ],
    pluginProjectReferences: [
        { path: '..\\KD8.Core.Exchanges.Engines\\KD8.Core.Exchanges.Engines.csproj' },
        { path: '..\\KD8.DataEnvelope.Common\\KD8.DataEnvelope.Common.csproj' },
    ],
    dataPackageAdditions: [
        { name: 'KD8.Core.Exchanges.Data', version: '8.0.1.114' },
        { name: 'Treetek.net8.Data', version: '8.0.8.292' },
    ],
};
